<ng-container>
  <div data-testid="container" [class]="'toggle-window-container rounded shadow-8 w-fit px-1 py-0.5'" [ngClass]="activeSelectionClass">
    <ng-container *ngFor="let op of options">
      <div class="option inline-block cursor-pointer p-2" data-testid="option" [ngClass]="{ 'activeOption shadow-9 rounded bg-white': op.id == activeSelection, 'disableOption pointer-events-none': disabled }" (click)="select(op)">
        <div class="option-text capitalize text-base font-bold font-secondary" [ngClass]="op.id === activeSelection ? activeSelectionTextClass : 'text-white/[0.3]'">{{ op.name }}</div>
      </div>
    </ng-container>
  </div>
</ng-container>
